module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.Questions), function(item, questionIndex) {
    return _c('v-row', {
      key: questionIndex
    }, [_c('v-col', {
      attrs: {
        "col": "12"
      }
    }, [_c('v-img', {
      staticClass: "user-avatar",
      attrs: {
        "src": _vm.questionUserProfile.avatar,
        "alt": "User Profile Image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user-display-name"
    }, [_vm._v(_vm._s(_vm.questionUserProfile.displayName))]), _vm._v(" "), _c('div', {
      staticClass: "post-question-datetime"
    }, [_vm._v(_vm._s(_vm.createdDate(item.createdAt)))]), _vm._v(" "), _c('div', {
      staticClass: "question"
    }, [_vm._v("\n              " + _vm._s(item.question) + "                          \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "answers-obj"
    }, _vm._l((item.answers), function(res, answerIndex) {
      return _c('v-row', {
        key: answerIndex
      }, [_c('v-col', {
        attrs: {
          "col": "12"
        }
      }, [_c('v-img', {
        staticClass: "user-avatar",
        attrs: {
          "src": res.profilePicture,
          "alt": "User Profile Image"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "user-display-name"
      }, [_vm._v(_vm._s(res.profileName))]), _vm._v(" "), _c('div', {
        staticClass: "post-question-datetime"
      }, [_vm._v(_vm._s(_vm.createdDate(res.createdAt)))]), _vm._v(" "), _c('div', {
        staticClass: "answers"
      }, [_vm._v(_vm._s(res.comment))])], 1)], 1)
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "reply-box noActive",
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "id": 'reply_question_' + questionIndex
      }
    }, [_c('form', [_c('v-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('v-textarea', {
      staticStyle: {
        "margin-bottom": "0px !important"
      },
      attrs: {
        "counter": "",
        "outlined": "",
        "placeholder": "reply here..."
      },
      model: {
        value: (_vm.comment),
        callback: function($$v) {
          _vm.comment = $$v
        },
        expression: "comment"
      }
    })], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "ma-2",
      attrs: {
        "text": "",
        "tile": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.submitClick(questionIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v("Submit\n                ")], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "ma-2",
      attrs: {
        "text": "",
        "tile": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.cancelClick(questionIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-cancel")]), _vm._v("Cancel\n                ")], 1)], 1)]), _vm._v(" "), (item.userID !== _vm.activeUser.id || item.answers.length > 0) ? _c('div', {
      staticClass: "reply-btn",
      attrs: {
        "id": 'reply_question_btn_' + questionIndex
      }
    }, [_c('v-btn', {
      staticClass: "ma-2",
      attrs: {
        "text": "",
        "tile": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.replyClick(questionIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-message")]), _vm._v("Reply\n              ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('hr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (questionIndex < _vm.Questions.length - 1),
        expression: "questionIndex < Questions.length - 1"
      }],
      staticStyle: {
        "margin-left": "auto",
        "margin-right": "auto"
      },
      attrs: {
        "width": "98%"
      }
    })], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a3f765e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignInvite/QandA.vue
// module id = 2245
// module chunks = 0